import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import options from '~/vuetify.options'

Vue.use(Vuetify)

export default new Vuetify(options)
